// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"438":"Login","841":"ResetPwd","999":"ChangePwd"}[chunkId] + "-legacy." + {"438":"b57c5a3f","841":"95373cdc","999":"165ba590"}[chunkId] + ".js";
};